import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IGNORE_META_MESSAGE } from '@sb/shared/util';
import { ToastService } from '@sb/ui/toast';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { MetaMessageSilencerService } from './meta-message-silencer.service';

@Injectable()
export class MetaInterceptor implements HttpInterceptor {
  private toast = inject(ToastService);

  #metaMessageSilencer = inject(MetaMessageSilencerService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse && event.body?.meta) {
          const { meta } = event.body;
          const ignoreMetaMessage =
            request?.headers.get('ignore-meta-message') === 'true' ||
            request.context.get(IGNORE_META_MESSAGE) ||
            this.#metaMessageSilencer.isSilenced();

          if (meta.request && meta.request.remote_addr) {
            environment.ipAddress = meta.request.remote_addr;
          }

          if (meta.status === 'ok' && meta.status_message && !ignoreMetaMessage) {
            this.toast.openSuccess(meta.status_message);
          }
        }
      }),
    );
  }
}
